export default function Drawer(theme) {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          top: 65,
          height: `calc(100% - 65px)`,
          overflowX: "hidden",
          overflowY: "auto",

          "&::-webkit-scrollbar": {
            width: 5,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 8,
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: theme.palette.primary.mainHover,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: theme.palette.primary.greyThread,
            borderRadius: theme.shape.customBorderRadius[0],
          },
          "&::-webkit-scrollbar-button": {
            display: "none",
            width: 0,
            height: 0,
          },
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.primary.transparent,
        },
      },
    },
  };
}
